import {HttpEmail} from "../Http";
export class AddEmailAPI {


public static employerSetupEmail(input: any) {
 
    var obj=JSON.stringify(input);
    var url="email/employeeSetupEmail"; 

    const resultMethod = HttpEmail.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
    
        return res;
      }).catch((e: any) => {
 
        return e.response;
      });
    return resultMethod; 
  }


  public static employeeAccountCreationEmail(input: any) {
   
    var obj=JSON.stringify(input);
    var url="email/employeeAccountCreationEmail"; 
    
    const resultMethod = HttpEmail.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
   
        return res;
      }).catch((e: any) => {
   
        return e.response;
      });
    return resultMethod; 
  }


  public static sendCaseCreationEmail(input: any) {
    
    var obj=JSON.stringify(input);
    var url="email/sendCaseCreationEmail"; 
    
    const resultMethod = HttpEmail.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
     
        return res;
      }).catch((e: any) => {
 
        return e.response;
      });
    return resultMethod; 
  }

  
public static employmentCreation(input: any) {
 
  var obj=JSON.stringify(input);
  var url="email/sendEmailWithOutAttachment"; 
  
  const resultMethod = HttpEmail.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
    
      return res;
    }).catch((e: any) => {
       
      return e.response;
    });
  return resultMethod; 
}
}